import React from 'react'
import styled from '@emotion/styled'
import { Grid as MUIGrid, GridProps as MUIGridProps } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { Typography } from '@mui/material'

type GridPairColumnHeaderProps = {
  children?: React.ReactNode
}

type GridPairItemProps = {
  children?: React.ReactNode
}

type GridPairKeyProps = {
  children?: React.ReactNode
}

type GridPairValueProps = {
  children?: React.ReactNode
}

const Grid = styled(MUIGrid)`
  display: flex !important;
  padding-top: 0px !important;
  flex-grow: 1 !important;
  margin-top: 0px !important;
`

const GridPairHeaderWrapper = styled.div``

const GridPairWrapper = styled.div`
  & > div > div {
    border-right: 1px solid ${Colors.border};
    padding-bottom: 0 !important;
    margin-bottom: ${Shapes.spacing[6]}px;
  }
  & > div > div:last-of-type {
    border-right: none;
  }
`

const GridPairColumnWrapper = styled.div`
  width: 100%;
`

const GridPairColumnHeaderWrapper = styled.div`
  padding: ${Shapes.spacing[6]}px 0;
`

const GridPairItemWrapper = styled.div`
  padding: ${Shapes.spacing[3]}px 0;
  border-bottom: 1px solid ${Colors.border};

  &:last-of-type {
    border-bottom: none;
  }
`

const GridPairKeyWrapper = styled.div`
  width: 100%;
`

const GridPairValueWrapper = styled.div`
  & p {
    line-break: auto;
  }
`

type GridPairHeaderProps = {
  children?: React.ReactNode
}

export const GridPairHeader = (props: GridPairHeaderProps) => {
  return (
    <GridPairHeaderWrapper>
      <Grid container spacing={6} justifyContent="space-between">
        {props.children}
      </Grid>
    </GridPairHeaderWrapper>
  )
}

type GridPairProps = {
  children?: React.ReactNode
}

export const GridPair = (props: GridPairProps) => {
  return (
    <GridPairWrapper>
      <Grid container spacing={6} justifyContent="space-between">
        {props.children}
      </Grid>
    </GridPairWrapper>
  )
}

export const GridPairColumn = (props: MUIGridProps) => {
  return (
    <Grid item {...props} className="grid-column">
      <GridPairColumnWrapper>{props.children}</GridPairColumnWrapper>
    </Grid>
  )
}

export const GridPairColumnHeader = (props: GridPairColumnHeaderProps) => {
  return (
    <GridPairColumnHeaderWrapper>
      <Typography variant="title2" color={Colors.textBlack}>
        {props.children}
      </Typography>
    </GridPairColumnHeaderWrapper>
  )
}

export const GridPairItem = (props: GridPairItemProps) => {
  const { children } = props
  return (
    <GridPairItemWrapper>
      <Grid container>{children}</Grid>
    </GridPairItemWrapper>
  )
}

export const GridPairKey = (props: GridPairKeyProps) => {
  return (
    <Grid item xs={6}>
      <GridPairKeyWrapper style={{ width: '100%' }}>
        {
          // if childrend is a string, then wrap it in a Typography component
          typeof props.children === 'string' ? (
            <Typography variant="textmdm" color={Colors.textDark}>
              {props.children}
            </Typography>
          ) : (
            props.children
          )
        }
      </GridPairKeyWrapper>
    </Grid>
  )
}

export const GridPairValue = (props: GridPairValueProps) => {
  return (
    <Grid item xs={6}>
      <GridPairValueWrapper>
        {
          // if childrend is a string, then wrap it in a Typography component
          typeof props.children === 'string' || typeof props.children === 'number' ? (
            <Typography variant="textmd" color={Colors.textBlack}>
              {props.children}
            </Typography>
          ) : (
            props.children
          )
        }
      </GridPairValueWrapper>
    </Grid>
  )
}
